import React from 'react';
import { getRequest } from '../Helper/ApiClient';
import { BrandInterface } from '../../Interface/Brand';

export type BrandsByLetter = {
  data: Record<string, BrandInterface[]>;
};

const useBrandsByLetter = (): {
  isSuccess: boolean;
  data: BrandsByLetter | null;
} => {
  const brands = getRequest<BrandInterface[]>(
    '/api/onlineshop/brands?sortBy=name'
  );

  return React.useMemo(() => {
    if (!brands.isSuccess || !brands.data) {
      return { isSuccess: false, data: null };
    }

    const grouped: Record<string, BrandInterface[]> = {};
    for (const b of brands.data) {
      const first = (b.name || '').trim();
      const key = first && /[A-Za-z]/.test(first[0])
        ? first[0].toUpperCase()
        : '#';
      (grouped[key] ||= []).push(b);
    }

    return {
      isSuccess: true,
      data: {
        data: grouped,
      },
    };
  }, [brands.isSuccess, brands.data]);
};

export default useBrandsByLetter;

